import React from 'react';

export const MainQr = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6963_35529)">
        <path d="M104 0H0V104H104V0Z" fill="white" />
        <path
          d="M31.5148 0.00341797H28.3633V3.1549H31.5148V0.00341797Z"
          fill="black"
        />
        <path
          d="M34.6652 0.00341797H31.5137V3.1549H34.6652V0.00341797Z"
          fill="black"
        />
        <path
          d="M47.2706 0.00341797H44.1191V3.1549H47.2706V0.00341797Z"
          fill="black"
        />
        <path
          d="M53.5753 0.00341797H50.4238V3.1549H53.5753V0.00341797Z"
          fill="black"
        />
        <path
          d="M59.878 0.00341797H56.7266V3.1549H59.878V0.00341797Z"
          fill="black"
        />
        <path
          d="M66.1808 0.00341797H63.0293V3.1549H66.1808V0.00341797Z"
          fill="black"
        />
        <path
          d="M75.6359 0.00341797H72.4844V3.1549H75.6359V0.00341797Z"
          fill="black"
        />
        <path
          d="M78.7862 0.00341797H75.6348V3.1549H78.7862V0.00341797Z"
          fill="black"
        />
        <path
          d="M34.6671 3.15576H31.5156V6.30724H34.6671V3.15576Z"
          fill="black"
        />
        <path
          d="M37.8175 3.15576H34.666V6.30724H37.8175V3.15576Z"
          fill="black"
        />
        <path
          d="M40.9679 3.15576H37.8164V6.30724H40.9679V3.15576Z"
          fill="black"
        />
        <path
          d="M44.1202 3.15576H40.9688V6.30724H44.1202V3.15576Z"
          fill="black"
        />
        <path
          d="M47.2706 3.15576H44.1191V6.30724H47.2706V3.15576Z"
          fill="black"
        />
        <path
          d="M50.423 3.15576H47.2715V6.30724H50.423V3.15576Z"
          fill="black"
        />
        <path
          d="M56.7257 3.15576H53.5742V6.30724H56.7257V3.15576Z"
          fill="black"
        />
        <path
          d="M59.878 3.15576H56.7266V6.30724H59.878V3.15576Z"
          fill="black"
        />
        <path
          d="M63.0304 3.15576H59.8789V6.30724H63.0304V3.15576Z"
          fill="black"
        />
        <path
          d="M66.1808 3.15576H63.0293V6.30724H66.1808V3.15576Z"
          fill="black"
        />
        <path
          d="M72.4835 3.15576H69.332V6.30724H72.4835V3.15576Z"
          fill="black"
        />
        <path
          d="M75.6359 3.15576H72.4844V6.30724H75.6359V3.15576Z"
          fill="black"
        />
        <path
          d="M37.8175 6.30225H34.666V9.45373H37.8175V6.30225Z"
          fill="black"
        />
        <path
          d="M40.9679 6.30225H37.8164V9.45373H40.9679V6.30225Z"
          fill="black"
        />
        <path
          d="M47.2706 6.30225H44.1191V9.45373H47.2706V6.30225Z"
          fill="black"
        />
        <path
          d="M56.7257 6.30225H53.5742V9.45373H56.7257V6.30225Z"
          fill="black"
        />
        <path
          d="M59.878 6.30225H56.7266V9.45373H59.878V6.30225Z"
          fill="black"
        />
        <path
          d="M63.0304 6.30225H59.8789V9.45373H63.0304V6.30225Z"
          fill="black"
        />
        <path
          d="M75.6359 6.30225H72.4844V9.45373H75.6359V6.30225Z"
          fill="black"
        />
        <path
          d="M31.5148 9.45459H28.3633V12.6061H31.5148V9.45459Z"
          fill="black"
        />
        <path
          d="M47.2706 9.45459H44.1191V12.6061H47.2706V9.45459Z"
          fill="black"
        />
        <path
          d="M50.423 9.45459H47.2715V12.6061H50.423V9.45459Z"
          fill="black"
        />
        <path
          d="M59.878 9.45459H56.7266V12.6061H59.878V9.45459Z"
          fill="black"
        />
        <path
          d="M63.0304 9.45459H59.8789V12.6061H63.0304V9.45459Z"
          fill="black"
        />
        <path
          d="M66.1808 9.45459H63.0293V12.6061H66.1808V9.45459Z"
          fill="black"
        />
        <path
          d="M72.4835 9.45459H69.332V12.6061H72.4835V9.45459Z"
          fill="black"
        />
        <path
          d="M75.6359 9.45459H72.4844V12.6061H75.6359V9.45459Z"
          fill="black"
        />
        <path
          d="M78.7862 9.45459H75.6348V12.6061H78.7862V9.45459Z"
          fill="black"
        />
        <path
          d="M28.3644 12.6094H25.2129V15.7609H28.3644V12.6094Z"
          fill="black"
        />
        <path
          d="M34.6671 12.6094H31.5156V15.7609H34.6671V12.6094Z"
          fill="black"
        />
        <path
          d="M37.8175 12.6094H34.666V15.7609H37.8175V12.6094Z"
          fill="black"
        />
        <path
          d="M44.1202 12.6094H40.9688V15.7609H44.1202V12.6094Z"
          fill="black"
        />
        <path
          d="M47.2706 12.6094H44.1191V15.7609H47.2706V12.6094Z"
          fill="black"
        />
        <path
          d="M50.423 12.6094H47.2715V15.7609H50.423V12.6094Z"
          fill="black"
        />
        <path
          d="M56.7257 12.6094H53.5742V15.7609H56.7257V12.6094Z"
          fill="black"
        />
        <path
          d="M63.0304 12.6094H59.8789V15.7609H63.0304V12.6094Z"
          fill="black"
        />
        <path
          d="M66.1808 12.6094H63.0293V15.7609H66.1808V12.6094Z"
          fill="black"
        />
        <path
          d="M69.3331 12.6094H66.1816V15.7609H69.3331V12.6094Z"
          fill="black"
        />
        <path
          d="M75.6359 12.6094H72.4844V15.7609H75.6359V12.6094Z"
          fill="black"
        />
        <path
          d="M78.7862 12.6094H75.6348V15.7609H78.7862V12.6094Z"
          fill="black"
        />
        <path
          d="M31.5148 15.7578H28.3633V18.9093H31.5148V15.7578Z"
          fill="black"
        />
        <path
          d="M34.6652 15.7578H31.5137V18.9093H34.6652V15.7578Z"
          fill="black"
        />
        <path
          d="M47.2726 15.7578H44.1211V18.9093H47.2726V15.7578Z"
          fill="black"
        />
        <path
          d="M53.5753 15.7578H50.4238V18.9093H53.5753V15.7578Z"
          fill="black"
        />
        <path
          d="M63.0284 15.7578H59.877V18.9093H63.0284V15.7578Z"
          fill="black"
        />
        <path
          d="M75.6359 15.7578H72.4844V18.9093H75.6359V15.7578Z"
          fill="black"
        />
        <path
          d="M28.3624 18.9102H25.2109V22.0616H28.3624V18.9102Z"
          fill="black"
        />
        <path
          d="M34.6652 18.9102H31.5137V22.0616H34.6652V18.9102Z"
          fill="black"
        />
        <path
          d="M40.9679 18.9102H37.8164V22.0616H40.9679V18.9102Z"
          fill="black"
        />
        <path
          d="M47.2726 18.9102H44.1211V22.0616H47.2726V18.9102Z"
          fill="black"
        />
        <path
          d="M53.5753 18.9102H50.4238V22.0616H53.5753V18.9102Z"
          fill="black"
        />
        <path
          d="M59.878 18.9102H56.7266V22.0616H59.878V18.9102Z"
          fill="black"
        />
        <path
          d="M66.1808 18.9102H63.0293V22.0616H66.1808V18.9102Z"
          fill="black"
        />
        <path
          d="M72.4835 18.9102H69.332V22.0616H72.4835V18.9102Z"
          fill="black"
        />
        <path
          d="M78.7862 18.9102H75.6348V22.0616H78.7862V18.9102Z"
          fill="black"
        />
        <path
          d="M28.3644 22.0649H25.2129V25.2164H28.3644V22.0649Z"
          fill="black"
        />
        <path
          d="M31.5148 22.0649H28.3633V25.2164H31.5148V22.0649Z"
          fill="black"
        />
        <path
          d="M37.8175 22.0649H34.666V25.2164H37.8175V22.0649Z"
          fill="black"
        />
        <path
          d="M40.9679 22.0649H37.8164V25.2164H40.9679V22.0649Z"
          fill="black"
        />
        <path
          d="M53.5753 22.0649H50.4238V25.2164H53.5753V22.0649Z"
          fill="black"
        />
        <path
          d="M56.7257 22.0649H53.5742V25.2164H56.7257V22.0649Z"
          fill="black"
        />
        <path
          d="M72.4835 22.0649H69.332V25.2164H72.4835V22.0649Z"
          fill="black"
        />
        <path
          d="M78.7862 22.0649H75.6348V25.2164H78.7862V22.0649Z"
          fill="black"
        />
        <path
          d="M9.45422 25.2173H6.30273V28.3688H9.45422V25.2173Z"
          fill="black"
        />
        <path
          d="M12.6046 25.2173H9.45312V28.3688H12.6046V25.2173Z"
          fill="black"
        />
        <path
          d="M22.0616 25.2173H18.9102V28.3688H22.0616V25.2173Z"
          fill="black"
        />
        <path
          d="M25.212 25.2173H22.0605V28.3688H25.212V25.2173Z"
          fill="black"
        />
        <path
          d="M28.3644 25.2173H25.2129V28.3688H28.3644V25.2173Z"
          fill="black"
        />
        <path
          d="M34.6652 25.2173H31.5137V28.3688H34.6652V25.2173Z"
          fill="black"
        />
        <path
          d="M37.8175 25.2173H34.666V28.3688H37.8175V25.2173Z"
          fill="black"
        />
        <path
          d="M40.9679 25.2173H37.8164V28.3688H40.9679V25.2173Z"
          fill="black"
        />
        <path
          d="M44.1202 25.2173H40.9688V28.3688H44.1202V25.2173Z"
          fill="black"
        />
        <path
          d="M47.2706 25.2173H44.1191V28.3688H47.2706V25.2173Z"
          fill="black"
        />
        <path
          d="M56.7257 25.2173H53.5742V28.3688H56.7257V25.2173Z"
          fill="black"
        />
        <path
          d="M66.1808 25.2173H63.0293V28.3688H66.1808V25.2173Z"
          fill="black"
        />
        <path
          d="M69.3331 25.2173H66.1816V28.3688H69.3331V25.2173Z"
          fill="black"
        />
        <path
          d="M72.4835 25.2173H69.332V28.3688H72.4835V25.2173Z"
          fill="black"
        />
        <path
          d="M75.6359 25.2173H72.4844V28.3688H75.6359V25.2173Z"
          fill="black"
        />
        <path
          d="M81.9366 25.2173H78.7852V28.3688H81.9366V25.2173Z"
          fill="black"
        />
        <path
          d="M85.089 25.2173H81.9375V28.3688H85.089V25.2173Z"
          fill="black"
        />
        <path
          d="M91.3937 25.2173H88.2422V28.3688H91.3937V25.2173Z"
          fill="black"
        />
        <path
          d="M3.14953 28.3716H-0.00195312V31.5231H3.14953V28.3716Z"
          fill="black"
        />
        <path
          d="M6.30187 28.3716H3.15039V31.5231H6.30187V28.3716Z"
          fill="black"
        />
        <path
          d="M9.45226 28.3716H6.30078V31.5231H9.45226V28.3716Z"
          fill="black"
        />
        <path
          d="M12.6046 28.3716H9.45312V31.5231H12.6046V28.3716Z"
          fill="black"
        />
        <path
          d="M18.9093 28.3716H15.7578V31.5231H18.9093V28.3716Z"
          fill="black"
        />
        <path
          d="M31.5148 28.3716H28.3633V31.5231H31.5148V28.3716Z"
          fill="black"
        />
        <path
          d="M34.6671 28.3716H31.5156V31.5231H34.6671V28.3716Z"
          fill="black"
        />
        <path
          d="M40.9679 28.3716H37.8164V31.5231H40.9679V28.3716Z"
          fill="black"
        />
        <path
          d="M44.1202 28.3716H40.9688V31.5231H44.1202V28.3716Z"
          fill="black"
        />
        <path
          d="M47.2706 28.3716H44.1191V31.5231H47.2706V28.3716Z"
          fill="black"
        />
        <path
          d="M53.5753 28.3716H50.4238V31.5231H53.5753V28.3716Z"
          fill="black"
        />
        <path
          d="M56.7257 28.3716H53.5742V31.5231H56.7257V28.3716Z"
          fill="black"
        />
        <path
          d="M69.3331 28.3716H66.1816V31.5231H69.3331V28.3716Z"
          fill="black"
        />
        <path
          d="M75.6359 28.3716H72.4844V31.5231H75.6359V28.3716Z"
          fill="black"
        />
        <path
          d="M81.9386 28.3716H78.7871V31.5231H81.9386V28.3716Z"
          fill="black"
        />
        <path
          d="M85.089 28.3716H81.9375V31.5231H85.089V28.3716Z"
          fill="black"
        />
        <path
          d="M94.5441 28.3716H91.3926V31.5231H94.5441V28.3716Z"
          fill="black"
        />
        <path
          d="M97.6964 28.3716H94.5449V31.5231H97.6964V28.3716Z"
          fill="black"
        />
        <path
          d="M103.999 28.3716H100.848V31.5231H103.999V28.3716Z"
          fill="black"
        />
        <path
          d="M12.6046 31.5161H9.45312V34.6676H12.6046V31.5161Z"
          fill="black"
        />
        <path
          d="M22.0597 31.5161H18.9082V34.6676H22.0597V31.5161Z"
          fill="black"
        />
        <path
          d="M34.6671 31.5161H31.5156V34.6676H34.6671V31.5161Z"
          fill="black"
        />
        <path
          d="M37.8175 31.5161H34.666V34.6676H37.8175V31.5161Z"
          fill="black"
        />
        <path
          d="M44.1202 31.5161H40.9688V34.6676H44.1202V31.5161Z"
          fill="black"
        />
        <path
          d="M47.2706 31.5161H44.1191V34.6676H47.2706V31.5161Z"
          fill="black"
        />
        <path
          d="M63.0304 31.5161H59.8789V34.6676H63.0304V31.5161Z"
          fill="black"
        />
        <path
          d="M66.1808 31.5161H63.0293V34.6676H66.1808V31.5161Z"
          fill="black"
        />
        <path
          d="M75.6359 31.5161H72.4844V34.6676H75.6359V31.5161Z"
          fill="black"
        />
        <path
          d="M78.7862 31.5161H75.6348V34.6676H78.7862V31.5161Z"
          fill="black"
        />
        <path
          d="M97.6964 31.5161H94.5449V34.6676H97.6964V31.5161Z"
          fill="black"
        />
        <path
          d="M100.847 31.5161H97.6953V34.6676H100.847V31.5161Z"
          fill="black"
        />
        <path
          d="M103.999 31.5161H100.848V34.6676H103.999V31.5161Z"
          fill="black"
        />
        <path
          d="M3.14953 34.6685H-0.00195312V37.8199H3.14953V34.6685Z"
          fill="black"
        />
        <path
          d="M6.30187 34.6685H3.15039V37.8199H6.30187V34.6685Z"
          fill="black"
        />
        <path
          d="M9.45422 34.6685H6.30273V37.8199H9.45422V34.6685Z"
          fill="black"
        />
        <path
          d="M18.9093 34.6685H15.7578V37.8199H18.9093V34.6685Z"
          fill="black"
        />
        <path
          d="M25.212 34.6685H22.0605V37.8199H25.212V34.6685Z"
          fill="black"
        />
        <path
          d="M34.6652 34.6685H31.5137V37.8199H34.6652V34.6685Z"
          fill="black"
        />
        <path
          d="M37.8175 34.6685H34.666V37.8199H37.8175V34.6685Z"
          fill="black"
        />
        <path
          d="M59.878 34.6685H56.7266V37.8199H59.878V34.6685Z"
          fill="black"
        />
        <path
          d="M63.0304 34.6685H59.8789V37.8199H63.0304V34.6685Z"
          fill="black"
        />
        <path
          d="M75.6359 34.6685H72.4844V37.8199H75.6359V34.6685Z"
          fill="black"
        />
        <path
          d="M78.7862 34.6685H75.6348V37.8199H78.7862V34.6685Z"
          fill="black"
        />
        <path
          d="M85.089 34.6685H81.9375V37.8199H85.089V34.6685Z"
          fill="black"
        />
        <path
          d="M88.2394 34.6685H85.0879V37.8199H88.2394V34.6685Z"
          fill="black"
        />
        <path
          d="M91.3937 34.6685H88.2422V37.8199H91.3937V34.6685Z"
          fill="black"
        />
        <path
          d="M94.5441 34.6685H91.3926V37.8199H94.5441V34.6685Z"
          fill="black"
        />
        <path
          d="M100.847 34.6685H97.6953V37.8199H100.847V34.6685Z"
          fill="black"
        />
        <path
          d="M9.45226 37.8232H6.30078V40.9747H9.45226V37.8232Z"
          fill="black"
        />
        <path
          d="M12.6066 37.8232H9.45508V40.9747H12.6066V37.8232Z"
          fill="black"
        />
        <path
          d="M15.7569 37.8232H12.6055V40.9747H15.7569V37.8232Z"
          fill="black"
        />
        <path
          d="M22.0616 37.8232H18.9102V40.9747H22.0616V37.8232Z"
          fill="black"
        />
        <path
          d="M31.5148 37.8232H28.3633V40.9747H31.5148V37.8232Z"
          fill="black"
        />
        <path
          d="M37.8175 37.8232H34.666V40.9747H37.8175V37.8232Z"
          fill="black"
        />
        <path
          d="M44.1202 37.8232H40.9688V40.9747H44.1202V37.8232Z"
          fill="black"
        />
        <path
          d="M50.423 37.8232H47.2715V40.9747H50.423V37.8232Z"
          fill="black"
        />
        <path
          d="M53.5753 37.8232H50.4238V40.9747H53.5753V37.8232Z"
          fill="black"
        />
        <path
          d="M56.7257 37.8232H53.5742V40.9747H56.7257V37.8232Z"
          fill="black"
        />
        <path
          d="M59.878 37.8232H56.7266V40.9747H59.878V37.8232Z"
          fill="black"
        />
        <path
          d="M63.0304 37.8232H59.8789V40.9747H63.0304V37.8232Z"
          fill="black"
        />
        <path
          d="M69.3312 37.8232H66.1797V40.9747H69.3312V37.8232Z"
          fill="black"
        />
        <path
          d="M75.6359 37.8232H72.4844V40.9747H75.6359V37.8232Z"
          fill="black"
        />
        <path
          d="M78.7862 37.8232H75.6348V40.9747H78.7862V37.8232Z"
          fill="black"
        />
        <path
          d="M81.9366 37.8232H78.7852V40.9747H81.9366V37.8232Z"
          fill="black"
        />
        <path
          d="M88.2394 37.8232H85.0879V40.9747H88.2394V37.8232Z"
          fill="black"
        />
        <path
          d="M100.847 37.8232H97.6953V40.9747H100.847V37.8232Z"
          fill="black"
        />
        <path
          d="M103.999 37.8232H100.848V40.9747H103.999V37.8232Z"
          fill="black"
        />
        <path
          d="M18.9093 40.9712H15.7578V44.1227H18.9093V40.9712Z"
          fill="black"
        />
        <path
          d="M25.212 40.9712H22.0605V44.1227H25.212V40.9712Z"
          fill="black"
        />
        <path
          d="M28.3644 40.9712H25.2129V44.1227H28.3644V40.9712Z"
          fill="black"
        />
        <path
          d="M40.9679 40.9712H37.8164V44.1227H40.9679V40.9712Z"
          fill="black"
        />
        <path
          d="M44.1202 40.9712H40.9688V44.1227H44.1202V40.9712Z"
          fill="black"
        />
        <path
          d="M47.2726 40.9712H44.1211V44.1227H47.2726V40.9712Z"
          fill="black"
        />
        <path
          d="M50.423 40.9712H47.2715V44.1227H50.423V40.9712Z"
          fill="black"
        />
        <path
          d="M63.0304 40.9712H59.8789V44.1227H63.0304V40.9712Z"
          fill="black"
        />
        <path
          d="M66.1808 40.9712H63.0293V44.1227H66.1808V40.9712Z"
          fill="black"
        />
        <path
          d="M69.3312 40.9712H66.1797V44.1227H69.3312V40.9712Z"
          fill="black"
        />
        <path
          d="M72.4835 40.9712H69.332V44.1227H72.4835V40.9712Z"
          fill="black"
        />
        <path
          d="M78.7862 40.9712H75.6348V44.1227H78.7862V40.9712Z"
          fill="black"
        />
        <path
          d="M81.9366 40.9712H78.7852V44.1227H81.9366V40.9712Z"
          fill="black"
        />
        <path
          d="M94.5441 40.9712H91.3926V44.1227H94.5441V40.9712Z"
          fill="black"
        />
        <path
          d="M6.30187 44.126H3.15039V47.2775H6.30187V44.126Z"
          fill="black"
        />
        <path
          d="M15.7569 44.126H12.6055V47.2775H15.7569V44.126Z"
          fill="black"
        />
        <path
          d="M22.0597 44.126H18.9082V47.2775H22.0597V44.126Z"
          fill="black"
        />
        <path
          d="M28.3644 44.126H25.2129V47.2775H28.3644V44.126Z"
          fill="black"
        />
        <path
          d="M31.5148 44.126H28.3633V47.2775H31.5148V44.126Z"
          fill="black"
        />
        <path
          d="M40.9679 44.126H37.8164V47.2775H40.9679V44.126Z"
          fill="black"
        />
        <path
          d="M53.5753 44.126H50.4238V47.2775H53.5753V44.126Z"
          fill="black"
        />
        <path
          d="M69.3331 44.126H66.1816V47.2775H69.3331V44.126Z"
          fill="black"
        />
        <path d="M85.089 44.126H81.9375V47.2775H85.089V44.126Z" fill="black" />
        <path
          d="M91.3937 44.126H88.2422V47.2775H91.3937V44.126Z"
          fill="black"
        />
        <path
          d="M94.5441 44.126H91.3926V47.2775H94.5441V44.126Z"
          fill="black"
        />
        <path
          d="M97.6964 44.126H94.5449V47.2775H97.6964V44.126Z"
          fill="black"
        />
        <path
          d="M3.14953 47.2788H-0.00195312V50.4303H3.14953V47.2788Z"
          fill="black"
        />
        <path
          d="M12.6046 47.2788H9.45312V50.4303H12.6046V47.2788Z"
          fill="black"
        />
        <path
          d="M25.212 47.2788H22.0605V50.4303H25.212V47.2788Z"
          fill="black"
        />
        <path
          d="M31.5148 47.2788H28.3633V50.4303H31.5148V47.2788Z"
          fill="black"
        />
        <path
          d="M34.6671 47.2788H31.5156V50.4303H34.6671V47.2788Z"
          fill="black"
        />
        <path
          d="M37.8175 47.2788H34.666V50.4303H37.8175V47.2788Z"
          fill="black"
        />
        <path
          d="M40.9679 47.2788H37.8164V50.4303H40.9679V47.2788Z"
          fill="black"
        />
        <path
          d="M44.1202 47.2788H40.9688V50.4303H44.1202V47.2788Z"
          fill="black"
        />
        <path
          d="M56.7257 47.2788H53.5742V50.4303H56.7257V47.2788Z"
          fill="black"
        />
        <path
          d="M63.0304 47.2788H59.8789V50.4303H63.0304V47.2788Z"
          fill="black"
        />
        <path
          d="M69.3331 47.2788H66.1816V50.4303H69.3331V47.2788Z"
          fill="black"
        />
        <path
          d="M72.4835 47.2788H69.332V50.4303H72.4835V47.2788Z"
          fill="black"
        />
        <path
          d="M75.6359 47.2788H72.4844V50.4303H75.6359V47.2788Z"
          fill="black"
        />
        <path
          d="M85.089 47.2788H81.9375V50.4303H85.089V47.2788Z"
          fill="black"
        />
        <path
          d="M94.5441 47.2788H91.3926V50.4303H94.5441V47.2788Z"
          fill="black"
        />
        <path
          d="M97.6964 47.2788H94.5449V50.4303H97.6964V47.2788Z"
          fill="black"
        />
        <path
          d="M100.847 47.2788H97.6953V50.4303H100.847V47.2788Z"
          fill="black"
        />
        <path
          d="M3.14953 50.4272H-0.00195312V53.5787H3.14953V50.4272Z"
          fill="black"
        />
        <path
          d="M6.30187 50.4272H3.15039V53.5787H6.30187V50.4272Z"
          fill="black"
        />
        <path
          d="M12.6046 50.4272H9.45312V53.5787H12.6046V50.4272Z"
          fill="black"
        />
        <path
          d="M15.7569 50.4272H12.6055V53.5787H15.7569V50.4272Z"
          fill="black"
        />
        <path
          d="M22.0597 50.4272H18.9082V53.5787H22.0597V50.4272Z"
          fill="black"
        />
        <path
          d="M25.212 50.4272H22.0605V53.5787H25.212V50.4272Z"
          fill="black"
        />
        <path
          d="M28.3644 50.4272H25.2129V53.5787H28.3644V50.4272Z"
          fill="black"
        />
        <path
          d="M34.6671 50.4272H31.5156V53.5787H34.6671V50.4272Z"
          fill="black"
        />
        <path
          d="M40.9679 50.4272H37.8164V53.5787H40.9679V50.4272Z"
          fill="black"
        />
        <path
          d="M44.1202 50.4272H40.9688V53.5787H44.1202V50.4272Z"
          fill="black"
        />
        <path
          d="M50.423 50.4272H47.2715V53.5787H50.423V50.4272Z"
          fill="black"
        />
        <path
          d="M53.5753 50.4272H50.4238V53.5787H53.5753V50.4272Z"
          fill="black"
        />
        <path
          d="M69.3331 50.4272H66.1816V53.5787H69.3331V50.4272Z"
          fill="black"
        />
        <path
          d="M78.7862 50.4272H75.6348V53.5787H78.7862V50.4272Z"
          fill="black"
        />
        <path
          d="M81.9386 50.4272H78.7871V53.5787H81.9386V50.4272Z"
          fill="black"
        />
        <path
          d="M85.089 50.4272H81.9375V53.5787H85.089V50.4272Z"
          fill="black"
        />
        <path
          d="M91.3937 50.4272H88.2422V53.5787H91.3937V50.4272Z"
          fill="black"
        />
        <path
          d="M100.847 50.4272H97.6953V53.5787H100.847V50.4272Z"
          fill="black"
        />
        <path
          d="M6.30187 53.5752H3.15039V56.7267H6.30187V53.5752Z"
          fill="black"
        />
        <path
          d="M9.45226 53.5752H6.30078V56.7267H9.45226V53.5752Z"
          fill="black"
        />
        <path
          d="M12.6046 53.5752H9.45312V56.7267H12.6046V53.5752Z"
          fill="black"
        />
        <path
          d="M15.7569 53.5752H12.6055V56.7267H15.7569V53.5752Z"
          fill="black"
        />
        <path
          d="M28.3644 53.5752H25.2129V56.7267H28.3644V53.5752Z"
          fill="black"
        />
        <path
          d="M47.2706 53.5752H44.1191V56.7267H47.2706V53.5752Z"
          fill="black"
        />
        <path
          d="M63.0304 53.5752H59.8789V56.7267H63.0304V53.5752Z"
          fill="black"
        />
        <path
          d="M66.1808 53.5752H63.0293V56.7267H66.1808V53.5752Z"
          fill="black"
        />
        <path
          d="M72.4835 53.5752H69.332V56.7267H72.4835V53.5752Z"
          fill="black"
        />
        <path
          d="M75.6359 53.5752H72.4844V56.7267H75.6359V53.5752Z"
          fill="black"
        />
        <path
          d="M81.9386 53.5752H78.7871V56.7267H81.9386V53.5752Z"
          fill="black"
        />
        <path
          d="M85.089 53.5752H81.9375V56.7267H85.089V53.5752Z"
          fill="black"
        />
        <path
          d="M91.3937 53.5752H88.2422V56.7267H91.3937V53.5752Z"
          fill="black"
        />
        <path
          d="M97.6964 53.5752H94.5449V56.7267H97.6964V53.5752Z"
          fill="black"
        />
        <path
          d="M3.14953 56.7261H-0.00195312V59.8776H3.14953V56.7261Z"
          fill="black"
        />
        <path
          d="M6.30187 56.7261H3.15039V59.8776H6.30187V56.7261Z"
          fill="black"
        />
        <path
          d="M22.0597 56.7261H18.9082V59.8776H22.0597V56.7261Z"
          fill="black"
        />
        <path
          d="M25.212 56.7261H22.0605V59.8776H25.212V56.7261Z"
          fill="black"
        />
        <path
          d="M31.5148 56.7261H28.3633V59.8776H31.5148V56.7261Z"
          fill="black"
        />
        <path
          d="M44.1202 56.7261H40.9688V59.8776H44.1202V56.7261Z"
          fill="black"
        />
        <path
          d="M50.423 56.7261H47.2715V59.8776H50.423V56.7261Z"
          fill="black"
        />
        <path
          d="M53.5753 56.7261H50.4238V59.8776H53.5753V56.7261Z"
          fill="black"
        />
        <path
          d="M59.878 56.7261H56.7266V59.8776H59.878V56.7261Z"
          fill="black"
        />
        <path
          d="M63.0304 56.7261H59.8789V59.8776H63.0304V56.7261Z"
          fill="black"
        />
        <path
          d="M69.3331 56.7261H66.1816V59.8776H69.3331V56.7261Z"
          fill="black"
        />
        <path
          d="M81.9386 56.7261H78.7871V59.8776H81.9386V56.7261Z"
          fill="black"
        />
        <path
          d="M85.089 56.7261H81.9375V59.8776H85.089V56.7261Z"
          fill="black"
        />
        <path
          d="M88.2394 56.7261H85.0879V59.8776H88.2394V56.7261Z"
          fill="black"
        />
        <path
          d="M97.6964 56.7261H94.5449V59.8776H97.6964V56.7261Z"
          fill="black"
        />
        <path
          d="M100.847 56.7261H97.6953V59.8776H100.847V56.7261Z"
          fill="black"
        />
        <path
          d="M9.45422 59.8765H6.30273V63.0279H9.45422V59.8765Z"
          fill="black"
        />
        <path
          d="M15.7569 59.8765H12.6055V63.0279H15.7569V59.8765Z"
          fill="black"
        />
        <path
          d="M18.9093 59.8765H15.7578V63.0279H18.9093V59.8765Z"
          fill="black"
        />
        <path
          d="M25.212 59.8765H22.0605V63.0279H25.212V59.8765Z"
          fill="black"
        />
        <path
          d="M28.3644 59.8765H25.2129V63.0279H28.3644V59.8765Z"
          fill="black"
        />
        <path
          d="M31.5148 59.8765H28.3633V63.0279H31.5148V59.8765Z"
          fill="black"
        />
        <path
          d="M44.1202 59.8765H40.9688V63.0279H44.1202V59.8765Z"
          fill="black"
        />
        <path
          d="M50.423 59.8765H47.2715V63.0279H50.423V59.8765Z"
          fill="black"
        />
        <path
          d="M56.7257 59.8765H53.5742V63.0279H56.7257V59.8765Z"
          fill="black"
        />
        <path
          d="M59.878 59.8765H56.7266V63.0279H59.878V59.8765Z"
          fill="black"
        />
        <path
          d="M72.4835 59.8765H69.332V63.0279H72.4835V59.8765Z"
          fill="black"
        />
        <path
          d="M91.3937 59.8765H88.2422V63.0279H91.3937V59.8765Z"
          fill="black"
        />
        <path
          d="M100.847 59.8765H97.6953V63.0279H100.847V59.8765Z"
          fill="black"
        />
        <path
          d="M103.999 59.8765H100.848V63.0279H103.999V59.8765Z"
          fill="black"
        />
        <path
          d="M12.6066 63.0288H9.45508V66.1803H12.6066V63.0288Z"
          fill="black"
        />
        <path
          d="M18.9093 63.0288H15.7578V66.1803H18.9093V63.0288Z"
          fill="black"
        />
        <path
          d="M22.0616 63.0288H18.9102V66.1803H22.0616V63.0288Z"
          fill="black"
        />
        <path
          d="M25.212 63.0288H22.0605V66.1803H25.212V63.0288Z"
          fill="black"
        />
        <path
          d="M34.6652 63.0288H31.5137V66.1803H34.6652V63.0288Z"
          fill="black"
        />
        <path
          d="M63.0304 63.0288H59.8789V66.1803H63.0304V63.0288Z"
          fill="black"
        />
        <path
          d="M66.1808 63.0288H63.0293V66.1803H66.1808V63.0288Z"
          fill="black"
        />
        <path
          d="M69.3312 63.0288H66.1797V66.1803H69.3312V63.0288Z"
          fill="black"
        />
        <path
          d="M78.7862 63.0288H75.6348V66.1803H78.7862V63.0288Z"
          fill="black"
        />
        <path
          d="M85.089 63.0288H81.9375V66.1803H85.089V63.0288Z"
          fill="black"
        />
        <path
          d="M94.5441 63.0288H91.3926V66.1803H94.5441V63.0288Z"
          fill="black"
        />
        <path
          d="M97.6944 63.0288H94.543V66.1803H97.6944V63.0288Z"
          fill="black"
        />
        <path
          d="M103.999 63.0288H100.848V66.1803H103.999V63.0288Z"
          fill="black"
        />
        <path
          d="M3.14953 66.1772H-0.00195312V69.3287H3.14953V66.1772Z"
          fill="black"
        />
        <path
          d="M6.30187 66.1772H3.15039V69.3287H6.30187V66.1772Z"
          fill="black"
        />
        <path
          d="M9.45226 66.1772H6.30078V69.3287H9.45226V66.1772Z"
          fill="black"
        />
        <path
          d="M12.6066 66.1772H9.45508V69.3287H12.6066V66.1772Z"
          fill="black"
        />
        <path
          d="M18.9093 66.1772H15.7578V69.3287H18.9093V66.1772Z"
          fill="black"
        />
        <path
          d="M31.5148 66.1772H28.3633V69.3287H31.5148V66.1772Z"
          fill="black"
        />
        <path
          d="M37.8175 66.1772H34.666V69.3287H37.8175V66.1772Z"
          fill="black"
        />
        <path
          d="M40.9679 66.1772H37.8164V69.3287H40.9679V66.1772Z"
          fill="black"
        />
        <path
          d="M50.423 66.1772H47.2715V69.3287H50.423V66.1772Z"
          fill="black"
        />
        <path
          d="M53.5753 66.1772H50.4238V69.3287H53.5753V66.1772Z"
          fill="black"
        />
        <path
          d="M56.7257 66.1772H53.5742V69.3287H56.7257V66.1772Z"
          fill="black"
        />
        <path
          d="M63.0304 66.1772H59.8789V69.3287H63.0304V66.1772Z"
          fill="black"
        />
        <path
          d="M66.1808 66.1772H63.0293V69.3287H66.1808V66.1772Z"
          fill="black"
        />
        <path
          d="M72.4835 66.1772H69.332V69.3287H72.4835V66.1772Z"
          fill="black"
        />
        <path
          d="M78.7862 66.1772H75.6348V69.3287H78.7862V66.1772Z"
          fill="black"
        />
        <path
          d="M103.999 66.1772H100.848V69.3287H103.999V66.1772Z"
          fill="black"
        />
        <path
          d="M9.45422 69.3315H6.30273V72.483H9.45422V69.3315Z"
          fill="black"
        />
        <path
          d="M12.6046 69.3315H9.45312V72.483H12.6046V69.3315Z"
          fill="black"
        />
        <path
          d="M15.7569 69.3315H12.6055V72.483H15.7569V69.3315Z"
          fill="black"
        />
        <path
          d="M18.9093 69.3315H15.7578V72.483H18.9093V69.3315Z"
          fill="black"
        />
        <path
          d="M22.0616 69.3315H18.9102V72.483H22.0616V69.3315Z"
          fill="black"
        />
        <path
          d="M31.5148 69.3315H28.3633V72.483H31.5148V69.3315Z"
          fill="black"
        />
        <path
          d="M34.6652 69.3315H31.5137V72.483H34.6652V69.3315Z"
          fill="black"
        />
        <path
          d="M40.9679 69.3315H37.8164V72.483H40.9679V69.3315Z"
          fill="black"
        />
        <path
          d="M56.7257 69.3315H53.5742V72.483H56.7257V69.3315Z"
          fill="black"
        />
        <path d="M59.878 69.3315H56.7266V72.483H59.878V69.3315Z" fill="black" />
        <path
          d="M63.0304 69.3315H59.8789V72.483H63.0304V69.3315Z"
          fill="black"
        />
        <path
          d="M66.1808 69.3315H63.0293V72.483H66.1808V69.3315Z"
          fill="black"
        />
        <path
          d="M69.3331 69.3315H66.1816V72.483H69.3331V69.3315Z"
          fill="black"
        />
        <path
          d="M72.4835 69.3315H69.332V72.483H72.4835V69.3315Z"
          fill="black"
        />
        <path
          d="M75.6359 69.3315H72.4844V72.483H75.6359V69.3315Z"
          fill="black"
        />
        <path
          d="M78.7862 69.3315H75.6348V72.483H78.7862V69.3315Z"
          fill="black"
        />
        <path d="M85.089 69.3315H81.9375V72.483H85.089V69.3315Z" fill="black" />
        <path
          d="M91.3937 69.3315H88.2422V72.483H91.3937V69.3315Z"
          fill="black"
        />
        <path
          d="M100.847 69.3315H97.6953V72.483H100.847V69.3315Z"
          fill="black"
        />
        <path
          d="M103.999 69.3315H100.848V72.483H103.999V69.3315Z"
          fill="black"
        />
        <path
          d="M6.30187 72.4844H3.15039V75.6359H6.30187V72.4844Z"
          fill="black"
        />
        <path
          d="M9.45226 72.4844H6.30078V75.6359H9.45226V72.4844Z"
          fill="black"
        />
        <path
          d="M12.6046 72.4844H9.45312V75.6359H12.6046V72.4844Z"
          fill="black"
        />
        <path
          d="M18.9093 72.4844H15.7578V75.6359H18.9093V72.4844Z"
          fill="black"
        />
        <path
          d="M28.3644 72.4844H25.2129V75.6359H28.3644V72.4844Z"
          fill="black"
        />
        <path
          d="M31.5148 72.4844H28.3633V75.6359H31.5148V72.4844Z"
          fill="black"
        />
        <path
          d="M37.8175 72.4844H34.666V75.6359H37.8175V72.4844Z"
          fill="black"
        />
        <path
          d="M40.9679 72.4844H37.8164V75.6359H40.9679V72.4844Z"
          fill="black"
        />
        <path
          d="M50.423 72.4844H47.2715V75.6359H50.423V72.4844Z"
          fill="black"
        />
        <path
          d="M56.7257 72.4844H53.5742V75.6359H56.7257V72.4844Z"
          fill="black"
        />
        <path
          d="M59.878 72.4844H56.7266V75.6359H59.878V72.4844Z"
          fill="black"
        />
        <path
          d="M63.0304 72.4844H59.8789V75.6359H63.0304V72.4844Z"
          fill="black"
        />
        <path
          d="M66.1808 72.4844H63.0293V75.6359H66.1808V72.4844Z"
          fill="black"
        />
        <path
          d="M81.9386 72.4844H78.7871V75.6359H81.9386V72.4844Z"
          fill="black"
        />
        <path
          d="M88.2394 72.4844H85.0879V75.6359H88.2394V72.4844Z"
          fill="black"
        />
        <path
          d="M94.5441 72.4844H91.3926V75.6359H94.5441V72.4844Z"
          fill="black"
        />
        <path
          d="M100.847 72.4844H97.6953V75.6359H100.847V72.4844Z"
          fill="black"
        />
        <path
          d="M103.999 72.4844H100.848V75.6359H103.999V72.4844Z"
          fill="black"
        />
        <path
          d="M3.14953 75.6304H-0.00195312V78.7819H3.14953V75.6304Z"
          fill="black"
        />
        <path
          d="M12.6046 75.6304H9.45312V78.7819H12.6046V75.6304Z"
          fill="black"
        />
        <path
          d="M18.9093 75.6304H15.7578V78.7819H18.9093V75.6304Z"
          fill="black"
        />
        <path
          d="M22.0597 75.6304H18.9082V78.7819H22.0597V75.6304Z"
          fill="black"
        />
        <path
          d="M28.3644 75.6304H25.2129V78.7819H28.3644V75.6304Z"
          fill="black"
        />
        <path
          d="M37.8175 75.6304H34.666V78.7819H37.8175V75.6304Z"
          fill="black"
        />
        <path
          d="M40.9679 75.6304H37.8164V78.7819H40.9679V75.6304Z"
          fill="black"
        />
        <path
          d="M47.2706 75.6304H44.1191V78.7819H47.2706V75.6304Z"
          fill="black"
        />
        <path
          d="M50.423 75.6304H47.2715V78.7819H50.423V75.6304Z"
          fill="black"
        />
        <path
          d="M53.5753 75.6304H50.4238V78.7819H53.5753V75.6304Z"
          fill="black"
        />
        <path
          d="M59.878 75.6304H56.7266V78.7819H59.878V75.6304Z"
          fill="black"
        />
        <path
          d="M72.4835 75.6304H69.332V78.7819H72.4835V75.6304Z"
          fill="black"
        />
        <path
          d="M78.7862 75.6304H75.6348V78.7819H78.7862V75.6304Z"
          fill="black"
        />
        <path
          d="M81.9386 75.6304H78.7871V78.7819H81.9386V75.6304Z"
          fill="black"
        />
        <path
          d="M85.089 75.6304H81.9375V78.7819H85.089V75.6304Z"
          fill="black"
        />
        <path
          d="M88.2394 75.6304H85.0879V78.7819H88.2394V75.6304Z"
          fill="black"
        />
        <path
          d="M91.3937 75.6304H88.2422V78.7819H91.3937V75.6304Z"
          fill="black"
        />
        <path
          d="M28.3644 78.7832H25.2129V81.9347H28.3644V78.7832Z"
          fill="black"
        />
        <path
          d="M34.6652 78.7832H31.5137V81.9347H34.6652V78.7832Z"
          fill="black"
        />
        <path
          d="M37.8175 78.7832H34.666V81.9347H37.8175V78.7832Z"
          fill="black"
        />
        <path
          d="M40.9679 78.7832H37.8164V81.9347H40.9679V78.7832Z"
          fill="black"
        />
        <path
          d="M50.423 78.7832H47.2715V81.9347H50.423V78.7832Z"
          fill="black"
        />
        <path
          d="M56.7257 78.7832H53.5742V81.9347H56.7257V78.7832Z"
          fill="black"
        />
        <path
          d="M59.878 78.7832H56.7266V81.9347H59.878V78.7832Z"
          fill="black"
        />
        <path
          d="M63.0304 78.7832H59.8789V81.9347H63.0304V78.7832Z"
          fill="black"
        />
        <path
          d="M69.3331 78.7832H66.1816V81.9347H69.3331V78.7832Z"
          fill="black"
        />
        <path
          d="M75.6359 78.7832H72.4844V81.9347H75.6359V78.7832Z"
          fill="black"
        />
        <path
          d="M78.7862 78.7832H75.6348V81.9347H78.7862V78.7832Z"
          fill="black"
        />
        <path
          d="M91.3937 78.7832H88.2422V81.9347H91.3937V78.7832Z"
          fill="black"
        />
        <path
          d="M28.3644 81.9375H25.2129V85.089H28.3644V81.9375Z"
          fill="black"
        />
        <path
          d="M40.9679 81.9375H37.8164V85.089H40.9679V81.9375Z"
          fill="black"
        />
        <path
          d="M47.2706 81.9375H44.1191V85.089H47.2706V81.9375Z"
          fill="black"
        />
        <path d="M50.423 81.9375H47.2715V85.089H50.423V81.9375Z" fill="black" />
        <path d="M59.878 81.9375H56.7266V85.089H59.878V81.9375Z" fill="black" />
        <path
          d="M69.3331 81.9375H66.1816V85.089H69.3331V81.9375Z"
          fill="black"
        />
        <path
          d="M75.6359 81.9375H72.4844V85.089H75.6359V81.9375Z"
          fill="black"
        />
        <path
          d="M78.7862 81.9375H75.6348V85.089H78.7862V81.9375Z"
          fill="black"
        />
        <path d="M85.089 81.9375H81.9375V85.089H85.089V81.9375Z" fill="black" />
        <path
          d="M91.3937 81.9375H88.2422V85.089H91.3937V81.9375Z"
          fill="black"
        />
        <path
          d="M94.5441 81.9375H91.3926V85.089H94.5441V81.9375Z"
          fill="black"
        />
        <path
          d="M31.5148 85.0898H28.3633V88.2413H31.5148V85.0898Z"
          fill="black"
        />
        <path
          d="M34.6652 85.0898H31.5137V88.2413H34.6652V85.0898Z"
          fill="black"
        />
        <path
          d="M40.9679 85.0898H37.8164V88.2413H40.9679V85.0898Z"
          fill="black"
        />
        <path
          d="M53.5753 85.0898H50.4238V88.2413H53.5753V85.0898Z"
          fill="black"
        />
        <path
          d="M59.878 85.0898H56.7266V88.2413H59.878V85.0898Z"
          fill="black"
        />
        <path
          d="M75.6359 85.0898H72.4844V88.2413H75.6359V85.0898Z"
          fill="black"
        />
        <path
          d="M78.7862 85.0898H75.6348V88.2413H78.7862V85.0898Z"
          fill="black"
        />
        <path
          d="M91.3917 85.0898H88.2402V88.2413H91.3917V85.0898Z"
          fill="black"
        />
        <path
          d="M94.5441 85.0898H91.3926V88.2413H94.5441V85.0898Z"
          fill="black"
        />
        <path
          d="M97.6944 85.0898H94.543V88.2413H97.6944V85.0898Z"
          fill="black"
        />
        <path
          d="M100.847 85.0898H97.6953V88.2413H100.847V85.0898Z"
          fill="black"
        />
        <path
          d="M103.997 85.0898H100.846V88.2413H103.997V85.0898Z"
          fill="black"
        />
        <path
          d="M34.6652 88.2427H31.5137V91.3942H34.6652V88.2427Z"
          fill="black"
        />
        <path
          d="M37.8175 88.2427H34.666V91.3942H37.8175V88.2427Z"
          fill="black"
        />
        <path
          d="M44.1202 88.2427H40.9688V91.3942H44.1202V88.2427Z"
          fill="black"
        />
        <path
          d="M59.878 88.2427H56.7266V91.3942H59.878V88.2427Z"
          fill="black"
        />
        <path
          d="M63.0284 88.2427H59.877V91.3942H63.0284V88.2427Z"
          fill="black"
        />
        <path
          d="M72.4835 88.2427H69.332V91.3942H72.4835V88.2427Z"
          fill="black"
        />
        <path
          d="M75.6359 88.2427H72.4844V91.3942H75.6359V88.2427Z"
          fill="black"
        />
        <path
          d="M78.7862 88.2427H75.6348V91.3942H78.7862V88.2427Z"
          fill="black"
        />
        <path
          d="M81.9366 88.2427H78.7852V91.3942H81.9366V88.2427Z"
          fill="black"
        />
        <path
          d="M85.089 88.2427H81.9375V91.3942H85.089V88.2427Z"
          fill="black"
        />
        <path
          d="M88.2394 88.2427H85.0879V91.3942H88.2394V88.2427Z"
          fill="black"
        />
        <path
          d="M91.3917 88.2427H88.2402V91.3942H91.3917V88.2427Z"
          fill="black"
        />
        <path
          d="M97.6944 88.2427H94.543V91.3942H97.6944V88.2427Z"
          fill="black"
        />
        <path
          d="M100.847 88.2427H97.6953V91.3942H100.847V88.2427Z"
          fill="black"
        />
        <path
          d="M28.3644 91.3931H25.2129V94.5445H28.3644V91.3931Z"
          fill="black"
        />
        <path
          d="M31.5148 91.3931H28.3633V94.5445H31.5148V91.3931Z"
          fill="black"
        />
        <path
          d="M34.6671 91.3931H31.5156V94.5445H34.6671V91.3931Z"
          fill="black"
        />
        <path
          d="M47.2706 91.3931H44.1191V94.5445H47.2706V91.3931Z"
          fill="black"
        />
        <path
          d="M56.7257 91.3931H53.5742V94.5445H56.7257V91.3931Z"
          fill="black"
        />
        <path
          d="M63.0304 91.3931H59.8789V94.5445H63.0304V91.3931Z"
          fill="black"
        />
        <path
          d="M66.1808 91.3931H63.0293V94.5445H66.1808V91.3931Z"
          fill="black"
        />
        <path
          d="M69.3331 91.3931H66.1816V94.5445H69.3331V91.3931Z"
          fill="black"
        />
        <path
          d="M72.4835 91.3931H69.332V94.5445H72.4835V91.3931Z"
          fill="black"
        />
        <path
          d="M75.6359 91.3931H72.4844V94.5445H75.6359V91.3931Z"
          fill="black"
        />
        <path
          d="M78.7862 91.3931H75.6348V94.5445H78.7862V91.3931Z"
          fill="black"
        />
        <path
          d="M88.2413 91.3931H85.0898V94.5445H88.2413V91.3931Z"
          fill="black"
        />
        <path
          d="M97.6964 91.3931H94.5449V94.5445H97.6964V91.3931Z"
          fill="black"
        />
        <path
          d="M28.3644 94.5454H25.2129V97.6969H28.3644V94.5454Z"
          fill="black"
        />
        <path
          d="M31.5148 94.5454H28.3633V97.6969H31.5148V94.5454Z"
          fill="black"
        />
        <path
          d="M34.6652 94.5454H31.5137V97.6969H34.6652V94.5454Z"
          fill="black"
        />
        <path
          d="M37.8175 94.5454H34.666V97.6969H37.8175V94.5454Z"
          fill="black"
        />
        <path
          d="M40.9679 94.5454H37.8164V97.6969H40.9679V94.5454Z"
          fill="black"
        />
        <path
          d="M44.1202 94.5454H40.9688V97.6969H44.1202V94.5454Z"
          fill="black"
        />
        <path
          d="M50.423 94.5454H47.2715V97.6969H50.423V94.5454Z"
          fill="black"
        />
        <path
          d="M53.5753 94.5454H50.4238V97.6969H53.5753V94.5454Z"
          fill="black"
        />
        <path
          d="M59.878 94.5454H56.7266V97.6969H59.878V94.5454Z"
          fill="black"
        />
        <path
          d="M78.7862 94.5454H75.6348V97.6969H78.7862V94.5454Z"
          fill="black"
        />
        <path
          d="M81.9366 94.5454H78.7852V97.6969H81.9366V94.5454Z"
          fill="black"
        />
        <path
          d="M85.089 94.5454H81.9375V97.6969H85.089V94.5454Z"
          fill="black"
        />
        <path
          d="M97.6964 94.5454H94.5449V97.6969H97.6964V94.5454Z"
          fill="black"
        />
        <path
          d="M37.8175 97.7002H34.666V100.852H37.8175V97.7002Z"
          fill="black"
        />
        <path
          d="M40.9679 97.7002H37.8164V100.852H40.9679V97.7002Z"
          fill="black"
        />
        <path
          d="M47.2706 97.7002H44.1191V100.852H47.2706V97.7002Z"
          fill="black"
        />
        <path
          d="M56.7257 97.7002H53.5742V100.852H56.7257V97.7002Z"
          fill="black"
        />
        <path
          d="M59.878 97.7002H56.7266V100.852H59.878V97.7002Z"
          fill="black"
        />
        <path
          d="M69.3331 97.7002H66.1816V100.852H69.3331V97.7002Z"
          fill="black"
        />
        <path
          d="M75.6359 97.7002H72.4844V100.852H75.6359V97.7002Z"
          fill="black"
        />
        <path
          d="M78.7862 97.7002H75.6348V100.852H78.7862V97.7002Z"
          fill="black"
        />
        <path
          d="M85.089 97.7002H81.9375V100.852H85.089V97.7002Z"
          fill="black"
        />
        <path
          d="M94.5441 97.7002H91.3926V100.852H94.5441V97.7002Z"
          fill="black"
        />
        <path
          d="M103.999 97.7002H100.848V100.852H103.999V97.7002Z"
          fill="black"
        />
        <path
          d="M34.6671 100.844H31.5156V103.996H34.6671V100.844Z"
          fill="black"
        />
        <path
          d="M37.8175 100.844H34.666V103.996H37.8175V100.844Z"
          fill="black"
        />
        <path
          d="M44.1202 100.844H40.9688V103.996H44.1202V100.844Z"
          fill="black"
        />
        <path
          d="M50.423 100.844H47.2715V103.996H50.423V100.844Z"
          fill="black"
        />
        <path
          d="M63.0304 100.844H59.8789V103.996H63.0304V100.844Z"
          fill="black"
        />
        <path
          d="M66.1808 100.844H63.0293V103.996H66.1808V100.844Z"
          fill="black"
        />
        <path
          d="M85.089 100.844H81.9375V103.996H85.089V100.844Z"
          fill="black"
        />
        <path
          d="M88.2413 100.844H85.0898V103.996H88.2413V100.844Z"
          fill="black"
        />
        <path
          d="M91.3937 100.844H88.2422V103.996H91.3937V100.844Z"
          fill="black"
        />
        <path
          d="M94.5441 100.844H91.3926V103.996H94.5441V100.844Z"
          fill="black"
        />
        <path
          d="M97.6964 100.844H94.5449V103.996H97.6964V100.844Z"
          fill="black"
        />
        <path
          d="M18.7513 0.00390625H3.30906H0V3.31296V18.7552V22.0643H3.30906H18.7513H22.0604V18.7552V3.31296V0.00390625H18.7513ZM18.7513 18.7552H3.30906V3.31296H18.7513V18.7552Z"
          fill="black"
        />
        <path
          d="M100.689 0.00390625H85.2466H81.9375V3.31296V18.7552V22.0643H85.2466H100.689H103.998V18.7552V3.31296V0.00390625H100.689ZM100.689 18.7552H85.2466V3.31296H100.689V18.7552Z"
          fill="black"
        />
        <path
          d="M18.7494 81.937H3.3071H-0.00195312V85.2461V100.688V103.997H3.3071H18.7494H22.0584V100.688V85.2461V81.937H18.7494ZM18.7494 100.688H3.3071V85.2461H18.7494V100.688Z"
          fill="black"
        />
        <path
          d="M15.7572 6.30225H6.30273V15.7567H15.7572V6.30225Z"
          fill="black"
        />
        <path
          d="M97.6966 6.30225H88.2422V15.7567H97.6966V6.30225Z"
          fill="black"
        />
        <path
          d="M15.7572 88.2427H6.30273V97.6971H15.7572V88.2427Z"
          fill="black"
        />
        <rect
          x="34.666"
          y="34.667"
          width="34.6663"
          height="34.6663"
          fill="url(#pattern0_6963_35529)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0_6963_35529"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_6963_35529" transform="scale(0.00293255)" />
        </pattern>
        <clipPath id="clip0_6963_35529">
          <rect width="104" height="104" fill="white" />
        </clipPath>
        <image
          id="image0_6963_35529"
          width="341"
          height="341"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
